export default __webpack_public_path__ + "static/media/splashPic.214d04d8.jpg";